import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Inject,
} from '@angular/core';
import { Subject } from 'rxjs';
import { InsightsService } from '@marketing/insights/insights.service';
import { takeUntil } from 'rxjs/operators';
import { FtInsightsItem } from '@search/interfaces/insights.interface';
import { WINDOW } from '@ng-web-apis/common';

@Component({
  selector: 'ft-insights-report',
  templateUrl: './insights-report.component.html',
  providers: [InsightsService],
})
export class InsightsReportComponent implements OnInit, OnDestroy {
  articleTable: string;
  articleList: Array<FtInsightsItem['_source']> = [];
  isDebugMode = false;
  componentDestroyed$: Subject<boolean> = new Subject();
  constructor(
    private insightsService: InsightsService,
    private cd: ChangeDetectorRef,
    @Inject(WINDOW) readonly windowRef: Window
  ) {}

  ngOnInit(): void {
    this.insightsService
      .getAricleAPIData$(null, 1000)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((response: any) => {
        const results = response?.results?.response?.hits?.hits;
        results.forEach((element: FtInsightsItem) => {
          this.articleList.push(element._source);
        });
        this.articleTable = this.insightsService
          .convertJSONToTable(this.articleList, 'insightsLibraryReport')
          .toString();
        this.cd.detectChanges();
      });
  }

  exportToExcel() {
    const htmlTable = this.windowRef.document.getElementById(
      'insightsLibraryReport'
    );
    import('xlsx').then((xlsx) => {
      const wb = xlsx.utils.table_to_book(htmlTable);
      return xlsx.writeFile(wb, 'InsightsLibraryReport.xlsx');
    });
  }

  ngOnDestroy(): void {
    // unsubscribe from Observables
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
